export const a11ySelection = (callback) => (e) => {
  const { type = '', key = null } = e || {};

  if (type === 'keydown' && key !== ' ' && key !== 'Enter') {
    return;
  }

  callback(e);
};

export const ngA11ySelection = (e) => {
  const { type = '', key = null } = e || {};

  if (type === 'keydown' && key !== ' ' && key !== 'Enter') {
    return false;
  }

  return true;
};

export const a11yPageRedirection = (language, pageTitle) => {
  const liveAnnouncerElement = document.getElementById('live-announcer');
  if (!liveAnnouncerElement) {
    return;
  }
  liveAnnouncerElement.textContent = (
    language['returns.general.a11y.announce_page_redirection'] || '$pageTitle'
  ).replaceAll('$pageTitle', pageTitle);
};
